import React from "react";
import { Form, FormControl } from "react-bootstrap";
import { QuestionInterface, AnswerInterface, ApiHelper, MessageInterface, ArrayHelper, DateHelper } from "../../helpers";

interface Props {
  question: QuestionInterface,
  answer: AnswerInterface,
  updateValue: (questionId: number, newValue: string) => void,
}

export const MessageAnswer: React.FC<Props> = props => {
  const [messages, setMessages] = React.useState<MessageInterface[]>(null);

  const handleChange = (e: any) => {
    let val = e.currentTarget.value;
    props.updateValue(props.question.id, val);
  }

  const getOptions = () => {
    const result: React.ReactElement[] = [];

    if (messages) {
      const cats = ArrayHelper.getStrings(messages, "category");
      cats.forEach(c => { result.push(getCategory(messages, c)); });
    }

    if (props.question && props.answer && !props.answer.value) {
      if (messages?.length > 0) props.updateValue(props.question.id, messages[0].id.toString())
    }
    return result;
  }

  const getCategory = (allMessages: MessageInterface[], categoryName: string) => {
    const messages = ArrayHelper.getAll(allMessages, "category", categoryName);
    const messageOptions: React.ReactElement[] = [];
    messages?.forEach(m => { messageOptions.push(<option key={m.id} value={m.id}>{m.name}</option>); });
    return (<optgroup label={categoryName || "Uncategorized"}>{messageOptions}</optgroup>);
  }

  const fetchData = () => {
    ApiHelper.get<MessageInterface[]>("/messages")
      .then(data => setMessages(data || []))
      .catch(err => console.error("Failed to load messages:", err));
  }

  React.useEffect(() => { fetchData() }, []); // eslint-disable-line

  let desc = (props.question.description) ? <> <span className="description">({props.question.description})</span></> : null;
  const selectedMessage = ArrayHelper.getOne(messages || [], "id", parseInt(props.answer?.value, 0));
  if (selectedMessage) {
    let updatedText = <span className="ms-auto" style={{ fontStyle: "italic", fontWeight: "lighter", fontSize: 12, paddingTop: 5 }}>Last updated: {DateHelper.getDisplayDuration(DateHelper.convertToDate(selectedMessage.lastModified))}</span>
    desc = (desc) ? <>{updatedText}{desc}</> : updatedText
  }

  return (
    <Form.Group className="mb-3">
      <label className="d-flex align-items-center w-100">{props.question.title}{desc}</label>
      <FormControl as="select" value={props.answer?.value} onChange={handleChange}>{getOptions()}</FormControl>
    </Form.Group>
  );

}